import React, { useState } from "react";
import PageTitleCard from "../../../templates/PageTitleCard";
import PageTitleHeading from "../../../templates/PageTitleHeading";
import "./applyform.css";
import { useParams, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../../../utils/BaseUrl";
import Swal from "sweetalert2";
import CircleLoading from "../../../../../common/Loading/CircleLoading";
import TraingleLoading from "../../../../../common/Loading/TraingleLoading";
import _ from "lodash";
import BackHome from "../../../../templates/BackHome";
import Slash from "../../../../templates/Slash";
import BackPath from "../../../../templates/BackPath";
import PageHeading from "../../../../templates/PageHeading";
import CurrentPath from "../../../../templates/CurrentPath";
import RightArrow from "../../../../templates/RightArrow";

const MAX_FILE_SIZE = 10 * 1024 * 1024;
const ApplyForm = () => {
  const [formDataValue, setFormDataValue] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    country: "",
    state: "",
    qualification: "",
    specialization: "",
    resume: "",

    first_nameStatus: "unchecked",
    last_nameStatus: "unchecked",
    emailStatus: "unchecked",
    phoneStatus: "unchecked",
    countryStatus: "unchecked",
    stateStatus: "unchecked",
    qualificationStatus: "unchecked",
    specializationStatus: "unchecked",
    resumeStatus: "unchecked",
  });

  const { id } = useParams();
  const navigate = useNavigate();
  const decodeId = (encodedId) => atob(encodedId);

  const decodedId = decodeId(id);
  const { data } = useQuery({
    queryKey: "getjobById",
    queryFn: () =>
      axios.get(`${BASEURL}job/${decodedId}`).then((res) => {
        return res?.data;
      }),
  });

  const mutation = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}job/${decodedId}/application`, values);
    },
    onSuccess: (response) => {
      if (response?.data?.message) {
        Swal.fire({
          title: response?.data?.message,
          icon: "success",
          draggable: false,
        }).then(() => {
          setFormDataValue({
            first_name: "",
            last_name: "",
            email: "",
            phone: "",
            country: "",
            state: "",
            qualification: "",
            specialization: "",
            resume: "",

            first_nameStatus: "unchecked",
            last_nameStatus: "unchecked",
            emailStatus: "unchecked",
            phoneStatus: "unchecked",
            countryStatus: "unchecked",
            stateStatus: "unchecked",
            qualificationStatus: "unchecked",
            specializationStatus: "unchecked",
            resumeStatus: "unchecked",
          });
          navigate("/careers");
        });
      } else if (response?.data?.error) {
        Swal.fire({
          title: "Email already submitted",
          icon: "error",
          draggable: false,
        });
        // .then(() => {
        //   setFormDataValue({
        //     first_name: "",
        //     last_name: "",
        //     email: "",
        //     phone: "",
        //     country: "",
        //     state: "",
        //     qualification: "",
        //     specialization: "",
        //     resume: "",

        //     first_nameStatus: "unchecked",
        //     last_nameStatus: "unchecked",
        //     emailStatus: "unchecked",
        //     phoneStatus: "unchecked",
        //     countryStatus: "unchecked",
        //     stateStatus: "unchecked",
        //     qualificationStatus: "unchecked",
        //     specializationStatus: "unchecked",
        //     resumeStatus: "unchecked",
        //   });
        // });
      }
    },
  });

  const handleChange = (e) => {
    const newData = { ...formDataValue };
    if (e?.target?.name == "first_name") {
      const allAlphabeticOnlyRegex = new RegExp("^[a-zA-Z ]{2,1000}$");
      if (allAlphabeticOnlyRegex.test(e.target.value?.trim())) {
        newData[e.target.name + "Status"] = "success";
      } else {
        newData[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e?.target?.name == "last_name") {
      const allAlphabeticOnlyRegex = new RegExp("^[a-zA-Z ]{1,1000}$");
      if (allAlphabeticOnlyRegex.test(e.target.value?.trim())) {
        newData[e.target.name + "Status"] = "success";
      } else {
        newData[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e?.target?.name == "email") {
      const allAlphabeticOnlyRegex = new RegExp(
        "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
      );
      if (allAlphabeticOnlyRegex.test(e.target.value?.trim())) {
        newData[e.target.name + "Status"] = "success";
      } else {
        newData[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e?.target?.name == "phone") {
      const allAlphabeticOnlyRegex = new RegExp("^[0-9]{10}$");
      if (allAlphabeticOnlyRegex.test(e.target.value?.trim())) {
        newData[e.target.name + "Status"] = "success";
      } else {
        newData[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e?.target?.name == "country") {
      const allAlphabeticOnlyRegex = new RegExp("^[a-zA-Z ]{1,1000}$");

      if (allAlphabeticOnlyRegex.test(e.target.value?.trim())) {
        newData[e.target.name + "Status"] = "success";
      } else {
        newData[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e?.target?.name == "state") {
      const allAlphabeticOnlyRegex = new RegExp("^[a-zA-Z ]{1,1000}$");

      if (allAlphabeticOnlyRegex.test(e.target.value?.trim())) {
        newData[e.target.name + "Status"] = "success";
      } else {
        newData[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e?.target?.name == "qualification") {
      const allAlphabeticOnlyRegex = new RegExp("^[a-zA-Z ]{1,1000}$");

      if (allAlphabeticOnlyRegex.test(e.target.value?.trim())) {
        newData[e.target.name + "Status"] = "success";
      } else {
        newData[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e?.target?.name == "specialization") {
      const allAlphabeticOnlyRegex = new RegExp("^[a-zA-Z ]{1,1000}$");

      if (allAlphabeticOnlyRegex.test(e.target.value?.trim())) {
        newData[e.target.name + "Status"] = "success";
      } else {
        newData[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    }

    newData[e.target.name] = e.target.value;
    setFormDataValue(newData);
  };
  const checkSubmit = () => {
    let status = true;

    if (
      formDataValue.first_nameStatus == "success" &&
      formDataValue.last_nameStatus == "success" &&
      formDataValue.phoneStatus == "success" &&
      formDataValue.qualificationStatus == "success" &&
      formDataValue.emailStatus == "success" &&
      formDataValue.specializationStatus == "success" &&
      formDataValue.resumeStatus == "success"
    ) {
      status = false;
    } else {
      status = true;
    }
    return status;
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [isDragActive, setIsDragActive] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > MAX_FILE_SIZE) {
        Swal.fire({
          title: "File size must be 10MB or Smaller",
          icon: "error",
          draggable: false,
        }).then(() => {
          setFormDataValue({
            ...formDataValue,
            resume: "",
            resumeStatus: "unchecked",
          });
        });

        return;
      }
      setSelectedFile(file);
      setFormDataValue({
        ...formDataValue,
        resume: file,
        resumeStatus: "success",
      });
    } else {
      setFormDataValue({
        ...formDataValue,
        resume: "",
        resumeStatus: "unchecked",
      });
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragActive(true);
  };

  const handleDragLeave = () => {
    setIsDragActive(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragActive(false);
    const file = event.dataTransfer.files[0];
    if (
      file &&
      (file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
    ) {
      if (file.size > MAX_FILE_SIZE) {
        Swal.fire({
          title: "File size must be 10MB or Smaller",
          icon: "error",
          draggable: false,
        }).then(() => {
          setFormDataValue({
            ...formDataValue,
            resume: "",
            resumeStatus: "unchecked",
          });
        });

        return;
      }
      setSelectedFile(file);
      setFormDataValue({
        ...formDataValue,
        resume: file,
        resumeStatus: "success",
      });
    } else {
      Swal.fire({
        title: "Only PDF, DOC, or DOCX  files are allowed!",
        icon: "error",
        draggable: false,
      });
    }
  };

  const handleAdd = (e) => {
    const formdata = new FormData();

    formdata.append("job_id", decodedId);
    formdata.append("first_name", formDataValue.first_name);
    formdata.append("last_name", formDataValue.last_name);
    formdata.append("email", formDataValue.email);
    formdata.append("phone", formDataValue.phone);
    formdata.append("country", formDataValue.country);
    formdata.append("state", formDataValue.state);
    formdata.append("qualification", formDataValue.qualification);
    formdata.append("specialization", formDataValue.specialization);
    formdata.append("resume", formDataValue.resume);

    mutation.mutate(formdata);
  };

  return (
    <div>
      <PageTitleCard>
        <PageHeading>Apply Form</PageHeading>
        <div className="flex justify-evenly items-center">
          <BackHome /> <RightArrow />{" "}
          <BackPath path={"/careers"}>Care..</BackPath> <RightArrow />{" "}
          <BackPath path={`/careers/deatils/${decodedId}`}>
            {_.capitalize(
              _.truncate(data?.title, { length: 10, omission: "..." })
            )}
          </BackPath>
          <RightArrow />
          <CurrentPath>Apply Form</CurrentPath>
        </div>
      </PageTitleCard>
      {mutation.isLoading && <TraingleLoading />}
      <div className="container mx-auto md:px-6 sm:px-6 max-sm:px-6">
        <div className="lg:p-20 md:p-4 sm:p-4 max-sm:p-4 my-10 border">
          <div className="grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 max-sm:grid-cols-1 applyform-box gap-10">
            <div className="realtive">
              <div className="flex items-center">
                <label>First Name</label>
                <span className="text-speed-red text-lg font-bold"> * </span>
              </div>
              <input
                value={formDataValue.first_name}
                name="first_name"
                onChange={(e) => handleChange(e)}
                className={`
                  ${
                    formDataValue.first_nameStatus == "success"
                      ? "carrer-success"
                      : formDataValue.first_nameStatus == "error"
                      ? "carrer-error"
                      : ""
                  }`}
              />

              {formDataValue.first_nameStatus == "error" && (
                <p className="text-sm font-semibold -mt-1.5 px-2 text-speed-red">
                  First Name should be Allowed Accept only Alphabets
                </p>
              )}
            </div>
            <div>
              <div className="flex items-center">
                <label>Last Name</label>
                <span className="text-speed-red text-lg font-bold"> * </span>
              </div>
              <input
                value={formDataValue.last_name}
                name="last_name"
                onChange={(e) => handleChange(e)}
                className={`
                  ${
                    formDataValue.last_nameStatus == "success"
                      ? "carrer-success "
                      : formDataValue.last_nameStatus == "error"
                      ? "carrer-error"
                      : ""
                  }`}
              />
              {formDataValue.last_nameStatus == "error" && (
                <p className="text-sm font-semibold -mt-1.5 px-2 text-speed-red">
                  Last Name should be Allowed Accept only Alphabets
                </p>
              )}
            </div>
            <div>
              <div className="flex items-center">
                <label>Email</label>
                <span className="text-speed-red text-lg font-bold"> * </span>
              </div>
              <input
                value={formDataValue.email}
                name="email"
                onChange={(e) => handleChange(e)}
                className={`
                  ${
                    formDataValue.emailStatus == "success"
                      ? "carrer-success "
                      : formDataValue.emailStatus == "error"
                      ? "carrer-error"
                      : ""
                  }`}
              />
              {formDataValue.emailStatus == "error" && (
                <p className="text-sm font-semibold -mt-1.5 px-2 text-speed-red">
                  Email Invalid
                </p>
              )}
            </div>
            <div>
              <div className="flex items-center">
                <label>Phone Number</label>
                <span className="text-speed-red text-lg font-bold"> * </span>
              </div>
              <input
                value={formDataValue.phone}
                type="number"
                name="phone"
                onChange={(e) => handleChange(e)}
                onKeyDown={(e) => {
                  if (e.key === "e" || e.key === "E") {
                    e.preventDefault();
                  }
                }}
                className={`
                  ${
                    formDataValue.phoneStatus == "success"
                      ? "carrer-success "
                      : formDataValue.phoneStatus == "error"
                      ? "carrer-error"
                      : ""
                  } no-spinner`}
                min={10}
                max={10}
              />
              {formDataValue.phoneStatus == "error" && (
                <p className="text-sm font-semibold -mt-1.5 px-2 text-speed-red">
                  Phone Number Invalid
                </p>
              )}
            </div>
            <div>
              <div className="flex items-center">
                <label>Country</label>
                <span className="text-speed-red text-lg font-bold"> * </span>
              </div>
              <input
                value={formDataValue.country}
                name="country"
                onChange={(e) => handleChange(e)}
                className={`
                  ${
                    formDataValue.countryStatus == "success"
                      ? "carrer-success "
                      : formDataValue.countryStatus == "error"
                      ? "carrer-error"
                      : ""
                  }`}
              />
              {formDataValue.countryStatus == "error" && (
                <p className="text-sm font-semibold -mt-1.5 px-2 text-speed-red">
                  Country Invalid
                </p>
              )}
            </div>
            <div>
              <div className="flex items-center">
                <label>State</label>
                <span className="text-speed-red text-lg font-bold"> * </span>
              </div>
              <input
                value={formDataValue.state}
                name="state"
                onChange={(e) => handleChange(e)}
                className={`
                  ${
                    formDataValue.stateStatus == "success"
                      ? "carrer-success "
                      : formDataValue.stateStatus == "error"
                      ? "carrer-error"
                      : ""
                  }`}
              />
              {formDataValue.stateStatus == "error" && (
                <p className="text-sm font-semibold -mt-1.5 px-2 text-speed-red">
                  State Invalid
                </p>
              )}
            </div>
            <div>
              <div className="flex items-center">
                <label>Highest qualification</label>
                <span className="text-speed-red text-lg font-bold"> * </span>
              </div>

              <input
                value={formDataValue.qualification}
                name="qualification"
                onChange={(e) => handleChange(e)}
                className={`
                  ${
                    formDataValue.qualificationStatus == "success"
                      ? "carrer-success "
                      : formDataValue.qualificationStatus == "error"
                      ? "carrer-error"
                      : ""
                  }`}
              />
              {formDataValue.qualificationStatus == "error" && (
                <p className="text-sm font-semibold -mt-1.5 px-2 text-speed-red">
                  Qualification Invalid
                </p>
              )}
            </div>
            <div>
              <div className="flex items-center">
                <label>Specialization</label>
                <span className="text-speed-red text-lg font-bold"> * </span>
              </div>
              <input
                value={formDataValue.specialization}
                name="specialization"
                onChange={(e) => handleChange(e)}
                className={`
                  ${
                    formDataValue.specializationStatus == "success"
                      ? "carrer-success "
                      : formDataValue.specializationStatus == "error"
                      ? "carrer-error"
                      : ""
                  }`}
              />
              {formDataValue.specializationStatus == "error" && (
                <p className="text-sm font-semibold -mt-1.5 px-2 text-speed-red">
                  Specialization Invalid
                </p>
              )}
            </div>
          </div>
          <div>
            <div className="flex items-center">
              <label className="font-semibold text-lg my-4">
                Upload Resume
              </label>
              <span className="text-speed-red text-lg font-bold"> * </span>
            </div>

            <div
              className={`border-2 border-dashed rounded-lg p-6 py-14 w-full text-center ${
                isDragActive
                  ? "border-sport-yellow bg-slate-100"
                  : "border-gray-300"
              } my-4`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <p className="text-gray-500 mb-6">
                {formDataValue.resume
                  ? formDataValue.resume.name
                  : "Drag and drop a PDF, DOC, or DOCX file here & File size must be 10MB or Smaller "}
              </p>
              <label
                htmlFor="file-upload"
                className="cursor-pointer px-4 py-2 bg-sport-yellow text-black font-semibold rounded hover:bg-forging-yellow"
              >
                Choose File
              </label>
              <input
                type="file"
                id="file-upload"
                className="hidden"
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange}
              />
            </div>
          </div>
          <div className="flex justify-end">
            <button
              className={` bg-sport-yellow py-3 px-10  lg:min-w-48 lg:max-w-48 rounded-lg font-semibold text-lg  md:w-full sm:w-full max-sm:w-full
                 ${checkSubmit() ? "cursor-not-allowed" : "cursor-pointer"}`}
              disabled={checkSubmit()}
              onClick={(e) => handleAdd(e)}
            >
              {mutation.isLoading ? <CircleLoading /> : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplyForm;
